import { FieldMapping, cleanString, parseBoolean } from './importExportService';

export const customerFieldMappings: FieldMapping[] = [
  { field: 'type', label: 'Type', required: true, transform: (v) => {
    const val = cleanString(v).toLowerCase();
    return val === 'organization' || val === 'cég' || val === 'organization' ? 'organization' : 'individual';
  }},
  { field: 'companyName', label: 'Company Name', transform: cleanString },
  { field: 'firstName', label: 'First Name', transform: cleanString },
  { field: 'lastName', label: 'Last Name', transform: cleanString },
  { field: 'email', label: 'Email', required: true, transform: cleanString },
  { field: 'phone', label: 'Phone', transform: cleanString },
  { field: 'taxNumber', label: 'Tax Number', transform: cleanString },
  { field: 'registrationNumber', label: 'Registration Number', transform: cleanString },
  { field: 'bankAccount', label: 'Bank Account', transform: cleanString },
  { field: 'notes', label: 'Notes', transform: cleanString },
  { field: 'isActive', label: 'Active', transform: parseBoolean },
  { field: 'address.street', label: 'Street', transform: cleanString },
  { field: 'address.city', label: 'City', transform: cleanString },
  { field: 'address.postalCode', label: 'Postal Code', transform: cleanString },
  { field: 'address.country', label: 'Country', transform: cleanString },
  { field: 'contactPerson.name', label: 'Contact Person Name', transform: cleanString },
  { field: 'contactPerson.email', label: 'Contact Person Email', transform: cleanString },
  { field: 'contactPerson.phone', label: 'Contact Person Phone', transform: cleanString },
  { field: 'contactPerson.position', label: 'Contact Person Position', transform: cleanString },
];

export const supplierFieldMappings: FieldMapping[] = [
  { field: 'name', label: 'Name', required: true, transform: cleanString },
  { field: 'companyName', label: 'Company Name', transform: cleanString },
  { field: 'taxNumber', label: 'Tax Number', transform: cleanString },
  { field: 'email', label: 'Email', transform: cleanString },
  { field: 'phone', label: 'Phone', transform: cleanString },
  { field: 'address.country', label: 'Country', transform: cleanString },
  { field: 'address.postalCode', label: 'Postal Code', transform: cleanString },
  { field: 'address.city', label: 'City', transform: cleanString },
  { field: 'address.street', label: 'Street', transform: cleanString },
  { field: 'address.houseNumber', label: 'House Number', transform: cleanString },
  { field: 'isActive', label: 'Active', transform: parseBoolean },
  { field: 'notes', label: 'Notes', transform: cleanString },
];

export const productFieldMappings: FieldMapping[] = [
  { field: 'code', label: 'Code', required: true, transform: cleanString },
  { field: 'name', label: 'Name', required: true, transform: cleanString },
  { field: 'description', label: 'Description', transform: cleanString },
  { field: 'type', label: 'Type', transform: (v) => {
    const val = cleanString(v).toLowerCase();
    if (val === 'service' || val === 'szolgáltatás') return 'service';
    if (val === 'package' || val === 'csomag') return 'package';
    return 'product';
  }},
  { field: 'unit', label: 'Unit', transform: (v) => {
    const val = cleanString(v).toLowerCase();
    const valid = ['db', 'kg', 'liter', 'méter', 'csomag', 'karton', 'óra', 'nap'];
    return valid.includes(val) ? val : 'db';
  }},
  { field: 'barcode', label: 'Barcode', transform: cleanString },
  { field: 'articleNumber', label: 'Article Number', transform: cleanString },
  { field: 'netPrice', label: 'Net Price', transform: (v) => parseFloat(v) || 0 },
  { field: 'grossPrice', label: 'Gross Price', transform: (v) => parseFloat(v) || 0 },
  { field: 'taxRate', label: 'Tax Rate', transform: cleanString },
  { field: 'manufacturer', label: 'Manufacturer', transform: cleanString },
  { field: 'warrantyDays', label: 'Warranty Days', transform: (v) => parseInt(v) || 0 },
  { field: 'isActive', label: 'Active', transform: parseBoolean },
  { field: 'notes', label: 'Notes', transform: cleanString },
];

export const leadFieldMappings: FieldMapping[] = [
  { field: 'name', label: 'Name', required: true, transform: cleanString },
  { field: 'company', label: 'Company', transform: cleanString },
  { field: 'email', label: 'Email', transform: cleanString },
  { field: 'phone', label: 'Phone', transform: cleanString },
  { field: 'status', label: 'Status', transform: (v) => {
    const val = cleanString(v).toLowerCase();
    if (['contacted', 'kapcsolatba lépve', 'kapcsolat'].includes(val)) return 'contacted';
    if (['qualified', 'minősített'].includes(val)) return 'qualified';
    if (['unqualified', 'nem minősített'].includes(val)) return 'unqualified';
    if (['converted', 'konvertált', 'konvertálva'].includes(val)) return 'converted';
    return 'new';
  }},
  { field: 'source', label: 'Source', transform: (v) => {
    const val = cleanString(v).toLowerCase();
    if (['website', 'weboldal', 'web'].includes(val)) return 'website';
    if (['referral', 'ajánlás'].includes(val)) return 'referral';
    if (['social_media', 'social', 'közösségi média', 'facebook', 'instagram', 'linkedin'].includes(val)) return 'social_media';
    if (['advertisement', 'hirdetés', 'ads'].includes(val)) return 'advertisement';
    if (['manual', 'kézi', 'manuális'].includes(val)) return 'manual';
    return val ? 'other' : 'manual';
  }},
  { field: 'score', label: 'Score', transform: (v) => {
    const n = parseInt(cleanString(v), 10);
    return isNaN(n) ? undefined : Math.max(0, Math.min(100, n));
  }},
  { field: 'nextFollowUpAt', label: 'Next Follow-up', transform: (v) => {
    const str = cleanString(v);
    if (!str) return undefined;
    const d = new Date(str);
    return isNaN(d.getTime()) ? undefined : d;
  }},
  { field: 'notes', label: 'Notes', transform: cleanString },
];
